import { render, staticRenderFns } from "./mind.vue?vue&type=template&id=2488fac6&scoped=true"
import script from "./mind.vue?vue&type=script&lang=js"
export * from "./mind.vue?vue&type=script&lang=js"
import style0 from "./mind.vue?vue&type=style&index=0&id=2488fac6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2488fac6",
  null
  
)

export default component.exports